package com.essntl.core.whatsapp.data.response

import com.essntl.features.message.domain.model.WhapiMessageAction
import kotlinx.serialization.Serializable

@Serializable
data class MessageActionDto(
    val target: String,
    val type: String,
    val emoji: String? = null,
) {
    fun toModel() =
        WhapiMessageAction(
            target = target,
            type = type,
            emoji = emoji,
        )
}